// extracted by mini-css-extract-plugin
module.exports = {"close":"ClosePaneButton_close__3vYJ7"};